import type { RequestConfig } from '@customTypes/index';
import type { WorkInviteItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type DeleteWorkInvite = {
  workInviteId: string;
};

export type DeleteWorkInviteParams = RequestConfig<DeleteWorkInvite>;

export const deleteWorkInvite = async ({
  params,
  config
}: DeleteWorkInviteParams) =>
  api.delete<WorkInviteItemDto>(
    `/api/work/invites/${params.workInviteId}`,
    config
  );
